"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subject = void 0;
const subject_def_1 = require("./subject-def");
const subject = () => ((target) => {
    const def = subject_def_1.ClassSubjectDef.getOrMakeFor(target);
    def.decorated();
    const proxyCtor = new Proxy(target, {
        construct: (target, args) => def.applyToInstance(new target(...args)),
    });
    return proxyCtor;
});
exports.subject = subject;
//# sourceMappingURL=subject-decorator.js.map